"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validatorJS = require("validator");
class IsUuidValidator {
    constructor(version) {
        this.version = version;
    }
    isValid(input) {
        if (input) {
            return validatorJS.isUUID(input, this.version);
        }
        return false;
    }
}
exports.IsUuidValidator = IsUuidValidator;
//# sourceMappingURL=IsUuidValidator.js.map